module.exports = __webpack_public_path__ + "static/an-le-hero-small-62991c7210c070e874cd43dd0bc70f14.jpg";